import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { MixDesignLocationResultDto } from '../models/mix-design-location.model';

@Injectable({
  providedIn: 'root',
})
export class MixDesignService {
    constructor(private http: HttpClient) {}

    getMixDesignSearchResults(mixDesignCode: string, mixReference: string): Observable<any> {
      const encodedCode = encodeURIComponent(mixDesignCode);
      return this.http.get<any>(`${environment.baseUrl}mixdesign/getmixdesignsearchresults?mixId=${encodedCode}&mixReference=${mixReference}`);
    }

    searchMixReference(value: string): Observable<any> {
      return this.http.get<any>(`${environment.baseUrl}mixdesign/searchmixreference?searchValue=${encodeURIComponent(value)}`);
    }

    getMixDesign(mixDesignCode: string): Observable<any> {
      const encodedCode = encodeURIComponent(mixDesignCode);
      return this.http.get<any>(`${environment.baseUrl}mixdesign/getmixdesign?mixId=${encodedCode}`);
    }

    createMixDesign(payload: any): Observable<any> {
      return this.http.post<any>(`${environment.baseUrl}mixdesign/addmixdesign`, payload);
    }

    updateMixDesign(mixDesignId: string, payload: any): Observable<any> {
      return this.http.post<any>(`${environment.baseUrl}mixdesign/updatemixdesign?mixId=${mixDesignId}`, payload);
    }

    getMixDesignById(id: string): Observable<any> {
      return this.http.get<any>(`${environment.baseUrl}mixdesign/getmixdesignbyid?mixId=${id}`);
    }

    getAllMixDesigns() {
      return this.http.get<any>(`${environment.baseUrl}mixdesign/getallmixdesigns`);
    }

    deleteMixDesign(id: string): Observable<any> {
      return this.http.delete<any>(`${environment.baseUrl}mixdesign/deletemixdesignbyid?mixId=${id}`);
    }

    getMixDesignsByLocation(latitude: number, longitude: number, radius: number): Observable<MixDesignLocationResultDto> {
      const params = new HttpParams()
        .set('latitude', latitude)
        .set('longitude', longitude)
        .set('radius', radius);
      return this.http.get<MixDesignLocationResultDto>(`${environment.baseUrl}mixdesign/getmixdesignsbylocation`, {
        params,
      });
    }
}